import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=1bb7c633&scoped=true&"
import script from "./Tarjeta.vue?vue&type=script&lang=ts&"
export * from "./Tarjeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7c633",
  null
  
)

export default component.exports